'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.constants = exports.isClientHandOffAction = exports.default = undefined;

var _actions = require('./actions');

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_actions).default;
    }
});
Object.defineProperty(exports, 'isClientHandOffAction', {
    enumerable: true,
    get: function get() {
        return _actions.isClientHandOffAction;
    }
});

var _constants = require('./constants');

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.constants = constants;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-client-handoff-action/dist/main/index.js
// module id = 510
// module chunks = 0